module.exports = __webpack_public_path__ + "static/img/main04.0ce40ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/main04.png
// module id = hkcK
// module chunks = 1